import { memo } from "react";
import { ECommerce } from "ui/organizms/Onboarding";

const BusinessInformation = () => (
    <ECommerce.BusinessInformation />
);

export default memo(BusinessInformation);
